import { knobSize } from '@/features/ui/inputs/components/Switch/constants'

export const layer1Size = {
    width: knobSize.width + 6,
    height: knobSize.height + 6,
}
export const layer1Offset = {
    top: -3 + 1,
    left: -3,
}

export const layer2Size = {
    width: knobSize.width,
    height: knobSize.height,
}
export const layer2Offset = {
    top: 1,
    left: 0,
}

export const layer3Size = {
    width: knobSize.width,
    height: knobSize.height,
}
export const layer3Offset = {
    top: 2,
    left: 0,
}
